export class InformacionGeneral {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            tipo_declarante: {
                value: [],
                export: false,
                header: '¿UD. es?',
                required: 'Seleccione alguna opción',
            },
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido',
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido',
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida',
            },
            canton: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Ciudad es requerida'
            },
            tipo_declaracion: {
                value: null,
                header: 'Tipo de declaración:',
                required: 'Tipo de declaración es requerido',
            },
            tipo_identificacion: {
                value: null,
                export: false,
                header: 'Tipo de documento:',
                required: 'Tipo de documento es requerido'
            },
            identificacion: {
                value: '',
                header: 'No. de Identificación:',
                required: 'Identificación es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            nombre_completo: {
                value: '',
                header: 'Nombre Completo:',
                required: 'Campo requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            nacionalidad: {
                value: null,
                header: 'Nacionalidad:',
                required: 'Nacionalidad es requerido.'
            },
            fecha_nacimiento: {
                value: new Date(),
                header: 'Fecha de nacimiento (día/mes/año):',
                required: 'Fecha de nacimiento es requerido'
            },
            estado_civil: {
                value: null,
                header: 'Estado civil:',
                required: 'Estado civil es requerido'
            },
            hijo_edad: {
                value: '',
                export: true,
                header: 'Hijos, # y edad:',
                required: 'Campo requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            direccion_domicilio: {
                value: '',
                export: true,
                header: 'Dirección domiciliaria:',
                required: 'Campo requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            tipo_vivienda: {
                value: null,
                header: 'Tipo de vivienda:',
                required: 'Tipo de vivienda es requerido'
            },
            pais_residencia: {
                value: null,
                header: 'País de residencia:',
                required: 'País es requerido'
            },
            provincia_residencia: {
                value: null,
                header: 'Provincia de residencia:',
                required: 'Provincia es requerido'
            },
            ciudad_residencia: {
                value: null,
                export: false,
                header: 'Ciudad de residencia:',
                required: 'Ciudad es requerida'
            },
            canton_residencia: {
                value: '',
                export: false,
                header: 'Ciudad:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Ciudad es requerida'
            },
            telefono: {
                value: '',
                header: 'Teléfono Domicilio:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 40,
                min: 4,
                required: 'Teléfono es requerida'
            },
            celular: {
                value: '',
                header: 'Teléfono Celular:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 40,
                min: 3,
                required: 'Celular es requerido'
            },
            email: {
                value: '',
                header: 'Correo Electrónico:',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            tipo_identificacion_cy: {
                value: null,
                export: false,
                header: 'Tipo de documento:',
                required: 'Tipo de documento es requerido'
            },
            identificacion_cy: {
                value: '',
                header: 'No. de Identificación:',
                required: 'Identificación es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            nombre_completo_cy: {
                value: '',
                header: 'Apellidos y Nombres Completos del (o la) Cónyuge o Conviviente:',
                required: 'Campo requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            actividad_economica_cy: {
                value: null,
                header: 'Actividad económica:',
                required: 'Actividad económica es requerido'
            },
            cargo_lugar_trabajo_cy: {
                value: '',
                header: 'Cargo y lugar de trabajo:',
                required: 'Campo requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            separacion_bienes: {
                value: null,
                header: 'Separación de bienes:',
                required: 'Separación de bienes es requerido'
            },
            liquidacion_sociedad_conyugal: {
                value: null,
                header: 'Liquidación de sociedad conyugal:',
                required: 'Liquidación de sociedad conyugal es requerido'
            },
        }
    }

    optionLabel = 'nombre';
    pattern = { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Correo no válido. E.g. example@email.com' };
}
